module.exports = __webpack_public_path__ + "static/img/2.a850368.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/eng/2.png
// module id = bXN9
// module chunks = 0